import { EnvironmentProviders, FactoryProvider, makeEnvironmentProviders, Provider } from '@angular/core';
import { getString, RemoteConfig } from '@angular/fire/remote-config';
import { NgxCookieConsentModule } from '@localia/ngx-cookie-consent';

export const provideCookieConsent = (remoteConfigKey: string) => {
  // console.log('provideCookieConsent', remoteConfigKey);
  const setFactory = (provider: Provider | EnvironmentProviders) => (remoteConfig: RemoteConfig) => {
    // console.log('provideCookieConsent4', remoteConfig, remoteConfigKey);
    if (remoteConfig) {
      const getedString = getString(remoteConfig, remoteConfigKey);
      return getedString ? JSON.parse(getedString) : (provider as FactoryProvider).useFactory();
    }
    return (provider as FactoryProvider).useFactory();
  };
  // console.log('provideCookieConsent2', remoteConfigKey);
  return makeEnvironmentProviders([
    ...(NgxCookieConsentModule.forRoot().providers as (Provider | EnvironmentProviders)[]).map(
      (provider, idx: number) => {
        // console.log('provideCookieConsent3', provider, idx);
        return idx === 0
          ? { provide: (provider as FactoryProvider).provide, useFactory: setFactory(provider), deps: [RemoteConfig] }
          : provider;
      },
    ),
  ]);
};
